// extracted by mini-css-extract-plugin
export default {"hideTooltip":"J8-z","fadeIn":"K8-z","delay":"L8-z","recommendedSizeTooltip":"M8-z"};